import axios from 'axios';
import ReactDOM from 'react-dom/client';
import { useEffect } from 'react';
import {
  MemoryRouter,
  useLocation
} from "react-router-dom";

import App from './App';
import './index.css';
import { UsuariosProvider } from './context/UsuariosContext';
import { obtenerRutaPublica } from './utils/rutaPublica';


// ======================================================
// AXIOS
// ======================================================

//axios.defaults.baseURL = 'http://localhost:4000';
//axios.defaults.baseURL = 'http://85.31.235.16:4000';
axios.defaults.baseURL = 'https://mrgestor.com/';
//axios.defaults.baseURL = '/';


// ======================================================
// CONFIGURACIÓN
// ======================================================

const STORAGE_ROUTE_KEY = "mrgestor_ultima_ruta";


// ======================================================
// OBTENER PRIMERA PARTE DE LA RUTA
// ======================================================

const obtenerRutaVisible = (pathname) => {

  if (!pathname || pathname === "/") {
    return "/";
  }

  if (pathname === "/login") {
    return "/login";
  }

  if (pathname === "/inicio") {
    return "/inicio";
  }

  const partes = pathname
    .split("/")
    .filter(Boolean);

  if (partes.length === 0) {
    return "/";
  }

  return `/${partes[0]}/`;
};


// ======================================================
// DETERMINAR RUTA INTERNA AL INICIAR
// ======================================================

const obtenerRutaInicial = () => {

  const rutaNavegador = window.location.pathname;
  const search = window.location.search || "";
  const hash = window.location.hash || "";


  // ====================================================
  // LANDING
  // ====================================================

  if (rutaNavegador === "/") {

    sessionStorage.removeItem(
      STORAGE_ROUTE_KEY
    );

    return obtenerRutaPublica();
  }


  // ====================================================
  // LOGIN
  // ====================================================

  if (rutaNavegador === "/login") {

    sessionStorage.removeItem(
      STORAGE_ROUTE_KEY
    );

    return "/login";
  }


  // ====================================================
  // RECUPERAR ÚLTIMA RUTA INTERNA
  // ====================================================

  const ultimaRuta = sessionStorage.getItem(
    STORAGE_ROUTE_KEY
  );


  /*
   * Ejemplo:
   *
   * Navegador:
   * /institucional/
   *
   * sessionStorage:
   * /institucional/programas/edit/123456
   *
   * React carga internamente:
   * /institucional/programas/edit/123456
   */

  if (ultimaRuta) {

    const rutaVisibleGuardada =
      obtenerRutaVisible(
        ultimaRuta.split("?")[0].split("#")[0]
      );

    const rutaVisibleNavegador =
      obtenerRutaVisible(rutaNavegador);


    /*
     * Solamente recuperamos la ruta si
     * pertenece al mismo módulo.
     */

    if (
      rutaVisibleGuardada ===
      rutaVisibleNavegador
    ) {

      return ultimaRuta;
    }

  }


  // ====================================================
  // COMPATIBILIDAD CON RUTAS COMPLETAS
  // ====================================================

  /*
   * Si por alguna razón todavía entra por:
   *
   * /instructor/edit/12345
   *
   * se permite cargarla normalmente.
   */

  const partes = rutaNavegador
    .split("/")
    .filter(Boolean);


  if (partes.length > 1) {

    return (
      rutaNavegador +
      search +
      hash
    );

  }


  // ====================================================
  // RUTA DE RESPALDO
  // ====================================================

  return "/inicio";
};


// ======================================================
// CONTROLADOR DE URL VISIBLE
// ======================================================

function ControlRutaVisible() {

  const location = useLocation();


  useEffect(() => {

    const rutaInterna =
      `${location.pathname}${location.search}${location.hash}`;


    // ==================================================
    // LANDING
    // ==================================================

    if (location.pathname === "/") {

      sessionStorage.removeItem(
        STORAGE_ROUTE_KEY
      );

      if (
        window.location.pathname !== "/"
      ) {

        window.history.replaceState(
          {},
          "",
          "/"
        );

      }

      return;
    }


    // ==================================================
    // LOGIN
    // ==================================================

    if (location.pathname === "/login") {

      sessionStorage.removeItem(
        STORAGE_ROUTE_KEY
      );

      if (
        window.location.pathname !== "/login"
      ) {

        window.history.replaceState(
          {},
          "",
          "/login"
        );

      }

      return;
    }


    // ==================================================
    // GUARDAR RUTA INTERNA REAL
    // ==================================================

    sessionStorage.setItem(
      STORAGE_ROUTE_KEY,
      rutaInterna
    );


    // ==================================================
    // MOSTRAR SOLO EL MÓDULO
    // ==================================================

    const rutaVisible =
      obtenerRutaVisible(
        location.pathname
      );


    /*
     * Ejemplo:
     *
     * Ruta interna:
     *
     * /institucional/guias/editar/1234
     *
     * Barra navegador:
     *
     * /institucional/
     */

    const rutaActualNavegador =
      window.location.pathname;


    if (
      rutaActualNavegador !== rutaVisible
    ) {

      window.history.replaceState(
        {},
        "",
        rutaVisible
      );

    }


  }, [
    location.pathname,
    location.search,
    location.hash
  ]);


  return null;
}


// ======================================================
// RUTA INICIAL
// ======================================================

const rutaInicial =
  obtenerRutaInicial();


// ======================================================
// REACT
// ======================================================

const root = ReactDOM.createRoot(
  document.getElementById('root')
);


root.render(

  <MemoryRouter
    initialEntries={[rutaInicial]}
  >

    <ControlRutaVisible />

    <UsuariosProvider>

      <App />

    </UsuariosProvider>

  </MemoryRouter>

);
